
/*
let visible = false;

    function toggleButtons() {
      const extraButtons = document.getElementById('extra-buttons');
      const buyBtn = document.getElementById('buyNowBtn');

      if (!visible) {
        extraButtons.style.display = 'flex';
        buyBtn.textContent = 'BUY NOW';
      } else {
        extraButtons.style.display = 'none';
        buyBtn.textContent = 'BUY NOW';
      }

      visible = !visible;
    }
    */

    function toggleOptions(id) {
    const options = document.getElementById(id);
    const currentDisplay = window.getComputedStyle(options).display;
    options.style.display = (currentDisplay === 'flex') ? 'none' : 'flex';
  }